import { useState, useEffect } from "react";
import { Container, Draggable } from "react-smooth-dnd";
import TopicDetails from "./TopicDetails";
import toNumber from "lodash/toNumber";
import map from "lodash/map";
// import orderBy from 'lodash/orderBy';
import "./style.css";

/* Utils */
function applyDrag(iterable, dropResult) {
  const { addedIndex, payload, removedIndex } = dropResult;

  const workValue = iterable.slice();

  if (null !== removedIndex) {
    workValue.splice(removedIndex, 1);
  }

  if (null !== addedIndex) {
    workValue.splice(addedIndex, 0, payload);
  }

  return workValue;
}
export function DraggableList({
  visibleTopics,
  updateListOfTopicsForSelectedCourse,
  courseId,
}) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (visibleTopics && visibleTopics.length > 0) {
      const DATA = [
        {
          items: visibleTopics,
          tint: 1,
        },
      ];
      setItems(DATA);
    }
  }, [visibleTopics]);

  return (
    <div className="layout__wrapper">
      <div>
        <Container
          getChildPayload={(index) => {
            return items[index];
          }}
          onDrop={(dropResult) => {
            console.log(dropResult);
            setItems(applyDrag(items, dropResult));
          }}
        >
          {items &&
            items.map((item, groupIndex) => {
              return (
                <Draggable key={item.id} dragClass="pointer" 
                dropPlaceholder={{
                  className: 'pointer'
                }}>
                  <div className={`holder holder--tint-${item.tint}`}>
                    <div className="holder__content">
                      <Container
                        className="list"
                        getChildPayload={(index) => {
                          return items[groupIndex].items[index];
                        }}
                        groupName="LEADS_OVERVIEW"
                        onDrop={(dropResult) => {
                          const newValue = applyDrag(
                            items[groupIndex].items,
                            dropResult
                          );
                          const workValue = items.slice();
                          workValue[groupIndex] = {
                            ...items[groupIndex],
                            items: newValue,
                          };

                          const payload = {
                            course_id: toNumber(courseId),
                            topic_id: map(workValue[0]['items'], item => toNumber(item.id)),
                          };

                          updateListOfTopicsForSelectedCourse(payload);

                          setItems(workValue);
                        }}
                        dragClass="pointer" 
                          dropPlaceholder={{
                            className: 'pointer'
                          }}
                      >
                        {item.items.map((topic) => (
                          <Draggable className="list__item" key={topic.id}  dragClass="pointer" 
                          dropPlaceholder={{
                            className: 'pointer'
                          }}>
                            <div className="card">
                              <TopicDetails
                                key={topic.id}
                                id={topic.id}
                                image={topic.cover_image}
                                title={topic.title}
                                files={topic.files}
                                quizzes={topic.quiz_count}
                                status={topic.topic_completed_status}
                                displayOrder={topic.display_order}
                                orderId={topic.id}
                              />
                            </div>
                          </Draggable>
                        ))}
                      </Container>
                    </div>
                  </div>
                </Draggable>
              );
            })}
        </Container>
      </div>
    </div>
  );
}

export default DraggableList;
